import * as React from "react";
import {Button} from "@mui/material";
import Box from "@mui/material/Box";

interface TwoLineBtnProps {
    topRow: string | React.JSX.Element
    bottomRow: string | React.JSX.Element
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
    className: string
}

export const TwoLineBtn: React.FC<TwoLineBtnProps> = (props): React.JSX.Element => {
    return (
        <Button
            className={props.className}
            variant="text"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                lineHeight: 0.7,
                textTransform: 'none',
                color: "black"
            }}
            onClick={props.onClick}
        >
            <Box component="span"
                 sx={{
                     display: 'flex',
                     alignItems: 'center'
                }}
            >
                {props.topRow}
            </Box>

            <Box component="span"
                 sx={{
                     display: 'flex',
                     alignItems: 'center',
                     fontSize: '0.9rem',
                     fontWeight: 400,
                     opacity: 0.7
                }}
            >
                {props.bottomRow}
            </Box>

        </Button>
    );
}